<div class="jit-td-cell-info">
  <div class="jit-td-cell-info__title">{{ title }}</div>
  <div class="jit-td-cell-info__descr">{{ descr }}</div>
</div>